<template>
  <div :class="$style.taskSkeleton">
    <div :class="$style.cardHead">
      <div :class="$style.image" />
    </div>

    <div :class="$style.head">
      <div :class="$style.reward">
        <div :class="$style.rewardItem" />
      </div>
    </div>

    <div :class="$style.progressWrapper">
      <div :class="$style.progress" />
      <div :class="$style.progressText" />
    </div>

    <div :class="$style.description">
      <div :class="$style.titleLine" />
      <div :class="$style.titleLine" />
    </div>

    <!-- Детали внизу -->
    <div :class="$style.details">
      <div :class="$style.status" />
      <div :class="$style.priorityButton" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useCssModule } from 'vue'

defineOptions({
  name: 'UiSkeletonTask'
})

const $style = useCssModule()
</script>

<style lang="scss" module>
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.skeletonItem {
  background: var-default(--skeleton-item-bg);
  border-radius: 0.8em;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    transform: translateX(-100%);
    background: linear-gradient(
      to right,
      transparent,
      hsla(0deg, 0%, 100%, 0.3),
      transparent
    );
    animation: shimmer 1.5s infinite;
  }
}

.taskSkeleton {
  background: color-get(--root-rgb-bg-card);
  padding: 1.6em;
  border-radius: 2.4em;
  height: 100%;
  border: 4px solid transparent;
  cursor: wait;
}

.cardHead {
  margin-bottom: 1.4em;
}

.image {
  @extend .skeletonItem;
  width: 100%;
  height: 0;
  padding-bottom: 76%;
  border-radius: 0;
}

.head {
  margin-bottom: 1em;
}

.reward {
  display: flex;
  flex-direction: column;
  gap: 0.4em;
}

.rewardItem {
  @extend .skeletonItem;
  height: 2.4em;
  width: 60%;
}

.progressWrapper {
  display: flex;
  align-items: center;
  margin-top: 1em;
  gap: 1.6em;
}

.progress {
  @extend .skeletonItem;
  height: 0.8em;
  width: 100%;
}

.progressText {
  @extend .skeletonItem;
  height: 1.2em;
  width: 3em;
}

.description {
  margin-top: 1em;
  margin-bottom: 1.6em;
}

.titleLine {
  @extend .skeletonItem;
  height: 1.6em;
  margin-bottom: 0.8em;
  width: 70%;
}

.details {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.status {
  @extend .skeletonItem;
  height: 2.4em;
  width: 8em;
  flex: 1 1;
}

.completed {
  display: flex;
  align-items: center;
  gap: 0.4em;
}

.icon {
  @extend .skeletonItem;
  width: 2em;
  height: 2em;
  border-radius: 50%;
}

.counter {
  @extend .skeletonItem;
  height: 1.6em;
  width: 3em;
}

.priorityButton {
  @extend .skeletonItem;
  height: 3.2em;
  width: 3.2em;
  border-radius: 50%;
  margin-left: 1em;
}
</style>
